import { Injectable } from '@angular/core';
import { ResponseModel } from '../../shared/models/response-model.model';
import { DataService } from '../../shared/services/data.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagifyUserService {

  constructor(private service : DataService) { }

  extendMsgiflySubscription(data: any) {
    let url = "api/App/User/extendRenewalDate";
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
      return response;
    })
    );
  }
}
